import React from 'react';
// import { Redirect } from 'react-router-dom';
import './report.scss';

import Header from '../../containers/Header/header';
import Footer from '../../containers/Footer/footer';

import { auth as AuthObject } from '../../services/login'
import '../../containers/Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import toastNotify from '../../utils/toastNotifier';
import getCompanies from '../../services/getCompanyList';
import getStoryByCompanyID from '../../services/getStoryByCompanyID';

import EmptyScreen from '../EmptyScreen/EmptyScreen';
import withRouter from '../../containers/withRouter';
import { Navigate } from 'react-router-dom';


class Report extends React.Component {
    constructor() {
        super();
        this.state = {
            companyID: '',
            currentCompanyID: '',
            companies: [],
            premiumStatus:2, // 0 - Non Premium, 1 - Premium , 2- All
            storyType:0,    // 0- All , 1 - Image , 2- Video
            tokencheck: true,
            publishedOnFilter: ''

        }
        this.multiStories;
        this.publishStoriesData;

        this.multipleCheckboxes;
        this.flag = false;
        this.companyListing;
        this.expire = [];
        this.created = [];
        this.deleted = '-';
        this.data = {
            companyId: this.state.companyID,
            status: "",
            page: "",
            size: 10
        }
        this.validateData(this.data);
    }

    statusMap = {
        0: "Deleted",
        1: "Active",
        2: "Expired",
        3: "Saved as Draft"
    }
    checkAuth = () => {
        AuthObject.authenticate(() => {
            if (cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)) {

                this.setState(() => ({
                    redirectToReferrer: true
                }))
            }
        })
    }

    setCompanyID = (e) => {
        console.log("comapnyytID: ", e.target.value);

        this.setState({
            companyID: e.target.value
        })
    }
    setStoryType = (e) =>{
        console.log(e.target.value);
        this.setState({
            storyType:e.target.value
        })
    }
    setPremiumStatus = (e) =>{
        console.log(e.target.value);
        this.setState({
            premiumStatus:e.target.value
        })
    }
    setPublishedOnFilter = (e) => {
        console.log(e.target.value);
        this.setState({
            publishedOnFilter:e.target.value
        })
    }
    componentDidUpdate() {
        if (this.flag == true) {
            var removeAdminData = document.querySelectorAll(".adminDataHidden");
            for (var index = 0; index < removeAdminData.length; index++) {
                var adminData = removeAdminData[index];

                adminData.classList.remove("adminDataHidden");
            }

        }

    }
    componentDidMount() {
        // this.refs.iScroll.addEventListener("scroll", () => {
        //     if (this.refs.iScroll.scrollTop + this.refs.iScroll.clientHeight >= this.refs.iScroll.scrollHeight) {
        //         this.data.page++;
        //         this.loadMoreStories(this.data);
        //     }
        // });
        var elem = document.getElementById("report");
        elem.classList.add("active");
        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        console.log("Inside allCompamyStories Function:", this.loginProfileInfo.email);
        var admins = ["triptee@iimjobs.com", "bharat@iimjobs.com", "puneet.pant@iimjobs.com","minisha@iimjobs.com"];
        for (var i = 0; i < admins.length; i++) {
            if (admins[i] === this.loginProfileInfo.email) {
                this.flag = true;
            }
        }
        console.log("flag:", this.flag);
        if (this.flag == true) {
            var removeAdminChecks = document.querySelectorAll(".adminCheckHidden");
            console.log("removeAdminChecks.length:", removeAdminChecks.length);


            for (var index = 0; index < removeAdminChecks.length; index++) {
                var admin = removeAdminChecks[index];
                admin.classList.remove("adminCheckHidden");
            }

        }
        let list = {};

        const companyList = async () => {
            let companiesResult = await getCompanies();

            if (!(companiesResult instanceof Error)) {
                if (companiesResult.status.code == "10200"){
                    list = companiesResult.data[0];

                    console.log("companyList: ", list);
                    this.getList = list;
                    // console.log(list.companies.length);
                    // let companyListing = <option>No company Found</option>;
                    // var companyListing = document.createElement('select');
                    if (typeof list === 'undefined') {
                        // console.log("if ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (Object.keys(list).length === 0) {
                        // console.log("else if-1 ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (list.companies.length) {
                        // console.log("else if-2 ran");
                        let teamsFromApi = list.companies.map(item => { return { value: item.id, display: item.companyName } })
                        this.setState({ companies: [{ value: '', display: 'Select Company' }].concat(teamsFromApi) });
                    }
                    else {
                        // console.log("else ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                }else{
                    toastNotify("3", "Some error occured while fetching companies list")
                }
            }else{
                const response = JSON.parse(companiesResult.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                else{
                    toastNotify("3", "Some error occured while fetching companies list")

                }
            }
        }

        companyList();

    }
    eventHandleClick() {

        var ui = document.querySelector(".profile-menu");
        ui.style.display = "none";
    }

    onSubmit = async (e) => {
        e.preventDefault();

        const data = {
            companyId: this.state.companyID,
        }

        this.validateData(data, e)
    }
    pad = (num) => {
        return ("0" + num).slice(-2);
    }
    dateConvertor = (timestampValue) => {

        var date = new Date(timestampValue);

        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        this.expire = dd + '/' + mm + '/' + date.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;

    }
    dateConvertorCD = (timestampValue, dateType) => {
        if (!timestampValue) {
            return;
        }
        var date = new Date(timestampValue);

        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        if (dateType == 'created') {
            this.created = dd + '/' + mm + '/' + date.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;
        } else if (dateType == 'deleted') {
            this.deleted = dd + '/' + mm + '/' + date.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;
        }
    }

    validateData = async (data, e) => {
            let result = await getStoryByCompanyID(data.companyId);
            console.log('result: ',result);
            if (result.length) {
                let rows = result.map((item, index) => {
                    return {
                        storyType: item.storyType,
                        s3Path: item.s3Path,
                        status: item.status,
                        publishOn: item.publishOn
                    }
                })
                this.setState({
                    companyList: result,
                    rows: rows,
                    currentCompanyID: this.state.companyID
                })
            }
            else {
                this.setState({
                    companyList: [],
                    rows: [],
                    currentCompanyID: ''
                })

                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;


                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                toastNotify(3, "No story found for this company");
            }
        // }
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        let activeStoryRows;
        let emptyScreen = null;
        let companyName = "";
        if (this.state.companyList && this.state.companyList.length) {
            activeStoryRows = (
                this.state.companyList.map((item, index) => {
                    // debugger;
                    this.deleted = '-';
                    this.dateConvertorCD(item.createdOn, 'created');
                    this.dateConvertorCD(item.deletedOn, 'deleted');
                    this.dateConvertor(item.expiryOn);
                    let videoClassName, imageClassName, buttonClassName, publishButtonClassName, multiSelectOption, companyDetail;
                    if (item.storyType == 1) {
                        videoClassName = "videoComponent hidden";
                        imageClassName = "imageComponent";
                    }
                    else if (item.storyType == 2) {
                        videoClassName = "videoComponent";
                        imageClassName = "imageComponent hidden";
                    }

                    if (item.status == 1) {
                        buttonClassName = "btn-default color_danger";
                        // publishButtonClassName = "btn-default color_green";
                        // publishButtonClassName = "hidden";
                        multiSelectOption = "hidden";
                    }
                    else if (item.status == 3) {
                        buttonClassName = "btn-default color_danger";
                        // publishButtonClassName = "btn-default color_green";
                        multiSelectOption = "story-select";
                    }
                    else {
                        buttonClassName = "hidden";
                        // publishButtonClassName = "btn-default color_green";
                        // publishButtonClassName = "hidden";
                        multiSelectOption = "hidden";
                    }

                    if(this.state.companies.length){
                        companyDetail = this.state.companies.filter(function(el){
                            if(el['value'] === item.companyId){
                                return el;
                            }
                        })   
                        if(companyDetail.length){
                            companyName = companyDetail[0].display;                     
                        }
                    }

                    let conditionalClassStoryType = this.state.storyType != 0 && this.state.storyType != item.storyType ? 'hidden' : '';
                    let conditionalClassPremiumStatus = this.state.premiumStatus != 2 && this.state.premiumStatus != item.isPremium ? 'hidden' : '';
                    let conditionalClassPublishedOnFilter = this.state.publishedOnFilter !== '' && (!item.publishOn.includes(this.state.publishedOnFilter)) ? 'hidden' : '';

                    let finalClass = '';
                    if(conditionalClassStoryType == 'hidden'){
                        finalClass = 'hidden';
                    }
                    if(conditionalClassPremiumStatus == 'hidden'){
                        finalClass = 'hidden';
                    }
                    if(conditionalClassPublishedOnFilter == 'hidden'){
                        finalClass = 'hidden';
                    }
                    return (
                        
                        <tr key={index} rowindex={index} className={finalClass}  >
                            <td>
                                <p>{item.storyId}</p>
                            </td>
                            <td>
                                <p>{companyName}</p>
                            </td>
                            <td>
                                <div className={videoClassName}>
                                    <video width="200" height="200" controls key={item.s3Path}>
                                        <source src={item.s3Path} type="video/mp4" />
                                    </video>
                                </div>
                                <div className={imageClassName}>
                                    <img src={item.s3Path} controls key={item.s3Path}/>
                                </div>

                            </td>
                            <td>
                                <p>{item.storyType == 2 ? 'Video' : 'Image'}</p>
                            </td>
                            <td>
                                <p>{item.isPremium == 1 ? 'Premium' : 'Non Premium'}</p>
                            </td>
                            <td>
                                <p>{this.statusMap[item.status]}</p>
                            </td>
                            <td>
                                <p>{item.publishOn}</p>
                            </td>
                            <td >
                                <p>{this.created}</p>
                            </td>
                            <td >
                                <p>{this.deleted}</p>
                            </td>
                            <td >
                                {/* <p>{this.state.goods[0]}</p> */}
                                <p>{this.expire}</p>
                            </td>
                            <td>
                                <p>{item.publishType == 2 ? 'Reel' : 'Story'}</p>
                            </td>
                            <td>
                                <p>{item.totalViewCount}</p>
                            </td>
                            <td>
                                <p>{item.totalClapCount}</p>
                            </td>
                            <td>
                                <p>{item.totalScrollCount}</p>
                            </td>
                            <td>
                                <a href={'/insights/' + item.storyId} target="_blank" className="btn-default">Show Insights</a>
                            </td>
                        </tr>
                    )
                })
            )
        }else{
            emptyScreen = (
                <EmptyScreen item="Reports" />
            )
        }



        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick}>
                <Header />
                <section className="listing_header">
                    <h1> Story Report</h1>
                    <div className="wrapper">
                        <div className="wrapperForm">
                            <div className="form-group">
                                <label>Company List:</label>
                                <select onChange={(e) => this.setCompanyID(e)}>
                                    {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                                </select>

                                <label>Story Type:</label>
                                <select onChange={(e) => this.setStoryType(e)}>
                                    <option key='0' value='' >Select Story Type</option>
                                    <option key='1' value='1'>Image</option>
                                    <option key='2' value='2'>Video</option>
                                </select>

                                <label>Premium Status:</label>
                                <select onChange={(e) => this.setPremiumStatus(e)}>
                                    <option key='0' value='2' >Select Premium Status</option>
                                    <option key='1' value='1'>Premium</option>
                                    <option key='2' value='0'>Non Premium</option>
                                </select>

                                <label>Published On:</label>
                                <select onChange={(e) => this.setPublishedOnFilter(e)}>
                                    <option key='' value='' >Select Published On</option>
                                    <option key='iimjobs' value='iimjobs'>iimjobs</option>
                                    <option key='hirist' value='hirist'>hirist</option>
                                </select>

                                <button type="submit" id="btnSubmit" className="btn-default" onClick={(e) => this.onSubmit(e)}>GO</button>
                            </div>
                        </div>

                        <div className="wrapperTable" style={{overflowX: 'scroll'}}>
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        <th className="table_header">Story ID</th>
                                        <th className="table_header">Company Name</th>
                                        <th className="table_header">Story</th>
                                        <th className="table_header">Story Type</th>
                                        <th className="table_header">Company Status</th>
                                        <th className="table_header">Status</th>
                                        <th className="table_header">Published On</th>
                                        <th className="table_header ">Created On</th>
                                        <th className="table_header ">Deleted On</th>
                                        <th className="table_header ">Expiry</th>
                                        <th className="table_header">Publish Type</th>
                                        <th className="table_header ">Total Views</th>
                                        <th className="table_header ">Total Claps</th>
                                        <th className="table_header ">Total Swipe Up</th>
                                        <th className="table_header">View Insights</th>

                                    </tr>
                                    {activeStoryRows}
                                </tbody>
                            </table>
                            {emptyScreen}
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Report);    